import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=4a2c28d4&scoped=true"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"
import style0 from "./Timer.vue?vue&type=style&index=0&id=4a2c28d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2c28d4",
  null
  
)

export default component.exports